function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import __ from 'ramda/src/__';
import CustomerCareKeys from '../../../../../locales/keys';
import { DBSS_DECIMAL_PRECISION } from '../../../../../customercare.constants';
import { CoreLocaleKeys, i18n, SessionSelectors } from 'invision-core';
function OverrideFinanceBriPopupController($ngRedux, $timeout) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      language: SessionSelectors.LanguageSelector(store)
    };
  };
  var controllerActions = {};
  var popupApi = null;
  this.$onInit = function () {
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.coreLocaleKeys = CoreLocaleKeys;
    _this.customerCareKeys = CustomerCareKeys;
    _this.dbssDecimalPrecision = DBSS_DECIMAL_PRECISION;
    var onRegisterApi = _this.config.onRegisterApi;
    _this.config.onRegisterApi = function (_ref) {
      var api = _ref.api;
      popupApi = Object.assign({}, api, {
        open: function open() {
          $timeout(function () {
            _this.resetForm();
            api.open();
          });
        }
      });
      onRegisterApi && onRegisterApi({
        api: popupApi
      });
    };
  };
  this.cancelEditPricing = function () {
    _this.closePopup();
  };
  this.closePopup = function () {
    popupApi.close();
  };
  this.onPriceChange = function () {
    var params = [];
    if (_this.editOption && _this.editOption.BillerRuleInstanceThumbnails.length) {
      var britObj = {
        optionId: _this.editOption.Id,
        brcId: _this.financeBriToEdit.BillerRuleConfigurationId,
        financeOverrides: _objectSpread(_objectSpread({
          Amount: _this.billerRuleDecisionDetail.amount
        }, !_this.isFullUpfrontPayment && {
          TermLength: _this.billerRuleDecisionDetail.termLength
        }), {}, {
          /*
          * For finance BRI, quantity will be 1.
          */
          Quantity: 1
        })
      };
      params.push(britObj);
    }
    _this.updateEditOptionPrice()(params);
  };
  this.resetForm = function () {
    var _this$editOption, _this$editOption$Bill, _this$editOption$Pric, _this$editOption$Pric2, _this$editOption$Pric3, _this$editOption$Bill2, _this$editOption$Bill3, _this$editOption$Pric4, _this$editOption$Pric5, _this$editOption$Pric6, _this$editOption2, _this$editOption2$Bil, _this$editOption2$Bil2, _this$editOption$Pric7, _this$editOption$Pric8, _this$editOption$Pric9;
    _this.popupTitle = "".concat(i18n.translate(_this.customerCareKeys.EDIT_BULK_PLAN.EDIT_BULK_PRICING), " ").concat(_this.editOption.Name);
    _this.financeBriToEdit = (_this$editOption = _this.editOption) === null || _this$editOption === void 0 ? void 0 : (_this$editOption$Bill = _this$editOption.BillerRuleInstanceThumbnails) === null || _this$editOption$Bill === void 0 ? void 0 : _this$editOption$Bill[0];
    _this.isFullUpfrontPayment = ((_this$editOption$Pric = _this.editOption.PricingPlanBillerRuleInstances) === null || _this$editOption$Pric === void 0 ? void 0 : (_this$editOption$Pric2 = _this$editOption$Pric.FinanceBillerRuleInstances) === null || _this$editOption$Pric2 === void 0 ? void 0 : (_this$editOption$Pric3 = _this$editOption$Pric2[0]) === null || _this$editOption$Pric3 === void 0 ? void 0 : _this$editOption$Pric3.FullUpfrontPayment) || false;
    _this.billerRuleDecisionDetail = {
      amount: ((_this$editOption$Bill2 = _this.editOption.BillerRuleInstanceThumbnails) === null || _this$editOption$Bill2 === void 0 ? void 0 : (_this$editOption$Bill3 = _this$editOption$Bill2[0]) === null || _this$editOption$Bill3 === void 0 ? void 0 : _this$editOption$Bill3.Amount) || ((_this$editOption$Pric4 = _this.editOption.PricingPlanBillerRuleInstances) === null || _this$editOption$Pric4 === void 0 ? void 0 : (_this$editOption$Pric5 = _this$editOption$Pric4.FinanceBillerRuleInstances) === null || _this$editOption$Pric5 === void 0 ? void 0 : (_this$editOption$Pric6 = _this$editOption$Pric5[0]) === null || _this$editOption$Pric6 === void 0 ? void 0 : _this$editOption$Pric6.ChargeAmount),
      termLength: ((_this$editOption2 = _this.editOption) === null || _this$editOption2 === void 0 ? void 0 : (_this$editOption2$Bil = _this$editOption2.BillerRuleDetails) === null || _this$editOption2$Bil === void 0 ? void 0 : (_this$editOption2$Bil2 = _this$editOption2$Bil[0]) === null || _this$editOption2$Bil2 === void 0 ? void 0 : _this$editOption2$Bil2.TermLength) || ((_this$editOption$Pric7 = _this.editOption.PricingPlanBillerRuleInstances) === null || _this$editOption$Pric7 === void 0 ? void 0 : (_this$editOption$Pric8 = _this$editOption$Pric7.FinanceBillerRuleInstances) === null || _this$editOption$Pric8 === void 0 ? void 0 : (_this$editOption$Pric9 = _this$editOption$Pric8[0]) === null || _this$editOption$Pric9 === void 0 ? void 0 : _this$editOption$Pric9.TermLength)
    };
    _this.isPlanOrServiceChange = _this.editOption.isPlanOrServiceSwap;
  };
  this.restoreDefaults = function (e) {
    var _this$editOption$Pric10, _this$editOption$Pric11, _this$editOption$Pric12;
    e.preventDefault();
    _this.billerRuleDecisionDetail = {
      amount: _this.financeBriToEdit.CatalogAmount,
      termLength: (_this$editOption$Pric10 = _this.editOption.PricingPlanBillerRuleInstances) === null || _this$editOption$Pric10 === void 0 ? void 0 : (_this$editOption$Pric11 = _this$editOption$Pric10.FinanceBillerRuleInstances) === null || _this$editOption$Pric11 === void 0 ? void 0 : (_this$editOption$Pric12 = _this$editOption$Pric11[0]) === null || _this$editOption$Pric12 === void 0 ? void 0 : _this$editOption$Pric12.TermLength
    };
    _this.onPriceChange();
  };
  this.savePricing = function () {
    if (_this.formApi.$valid) {
      if (_this.isModify) {
        _this.editOption = Object.assign({}, _this.editOption, {
          isPlanOrServiceSwap: _this.isPlanOrServiceChange
        });
        _this.saveOptionEdit()(_this.editOption);
        _this.setEditOption()(_this.editOption);
      }
      _this.saveBulkPricing()(_this.editOption);
      _this.updateCart()(function () {
        _this.closePopup();
      });
    }
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
}
export default {
  template: require('./override.finance.bri.popup.html'),
  bindings: {
    config: '<',
    editOption: '<',
    isModify: '<',
    restoreOptionDefaultPricing: '&',
    saveOptionEdit: '&',
    saveBulkPricing: '&',
    setEditOption: '&',
    updateCart: '&',
    updateEditOptionPrice: '&'
  },
  controllerAs: 'OverrideFinanceBriPopupController',
  controller: OverrideFinanceBriPopupController
};